import React from 'react';
import { List } from 'immutable';
import { Fade } from 'react-awesome-reveal';
import Button from '../../../components/Button';
import Container from '../../../components/Container';
import Teaser from '../../../components/Teaser';
import TeaserSmall from '../../../components/TeaserSmall';
import { DEFAULT_FADE_DURATION_MS } from '../../../config/constants';

import './style.scss';

const ParagraphStoriesSelection = ({ entity }) => {
  const title = entity.getIn(['field_title', 0, 'value'], '');
  const link = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));
  const paragraphId = entity.getIn(['id', 0, 'value']);
  const paragraphKey = `paragraph:${paragraphId}`;

  let main = [];
  let rest = [];

  entity.getIn(['field_projects_sia_stories'], List()).map((entity, index) => {
    index === 0
      ? main.push(entity.getIn(['entity']))
      : rest.push(entity.getIn(['entity']));
  });

  return (
    <div id={paragraphKey} className="Paragraph ParagraphStoriesSelection">
      <Container>
        {title && <h2>{title}</h2>}
        <div className="ParagraphStoriesSelection__wrapper">
          {main.length > 0 && main.map((entity) => {
            const uuid = entity.getIn(['uuid', 0, 'value']);
            const langcode = entity.getIn(['langcode', 0, 'value']);
            return (
              <div key={`${uuid}:${langcode}`} className="ParagraphStoriesSelection__main">
                <Fade triggerOnce duration={DEFAULT_FADE_DURATION_MS}>
                  <Teaser
                    entity={entity}
                    showBody
                  />
                </Fade>
              </div>
            );
          })}
          <div className="ParagraphStoriesSelection__rest">
            {rest.length > 0 && rest.map((entity) => {
              const uuid = entity.getIn(['uuid', 0, 'value']);
              const langcode = entity.getIn(['langcode', 0, 'value']);
              return (
                <div key={`${uuid}:${langcode}`}>
                  <Fade triggerOnce duration={DEFAULT_FADE_DURATION_MS}>
                    <TeaserSmall
                      entity={entity}
                    />
                  </Fade>
                </div>
              );
            })}
          </div>
        </div>
      </Container>
      <Container>
        {link && (
          <div className="ParagraphStoriesSelection__button">
            <Button
              href={link}
              primary
              withIcon
              buttonIcon
            >
              {entity.getIn(['field_link', 0, 'title'], '')}
            </Button>
          </div>
        )}
      </Container>
    </div>
  );
};

export default ParagraphStoriesSelection;
